import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '.';

export const reducers = {
  setSelectedFilters(state, action) {
    const {
      currentStep,
      attributeIdentifier,
      displayName,
      value,
      inputType,
      id,
    } = action.payload;

    const itemExists = state[currentStep].filter.attributes.find(
      item => item.attributeIdentifier === attributeIdentifier,
    );

    if (itemExists) {
      state[currentStep].filter.attributes = state[
        currentStep
      ].filter.attributes.map(item => {
        if (item.attributeIdentifier === attributeIdentifier) {
          const updatedValues = item.values.includes(value)
            ? item.values.filter(val => val !== value)
            : [...item.values, value];
          return {
            ...item,
            values: ['radioGroup', 'select'].includes(inputType)
              ? [value]
              : updatedValues,
            id:
              attributeIdentifier === 'DifferentialPressure'
                ? id
                : attributeIdentifier,
          };
        }

        return item;
      });
    }

    if (!itemExists) {
      state[currentStep].filter.attributes = [
        ...state[currentStep].filter.attributes,
        {
          attributeIdentifier,
          displayName,
          values: [value],
          inputType,
          id:
            attributeIdentifier === 'DifferentialPressure'
              ? id
              : attributeIdentifier,
        },
      ];
    }

    if (
      state[currentStep].filter.attributes.every(
        item => item.values.length === 0,
      )
    ) {
      state[currentStep] = initialState[currentStep];
    } else {
      state[currentStep].filter.attributes = state[
        currentStep
      ].filter.attributes.filter(item => {
        return item.values.length !== 0;
      });
    }
  },
  setBasicForm(state, action) {
    const { currentStep, basicForm } = action.payload;

    state[currentStep].filter.basicForm = basicForm;
    //updating the basic form type filter value in attributes array
    state[currentStep].filter.attributes = initialState[
      currentStep
    ].filter.attributes.map(filterItem => {
      if (filterItem.attributeIdentifier === 'basicForm') {
        return {
          ...filterItem,
          values: [basicForm],
        };
      }
      return filterItem;
    });
    // removing and adding static filters based on actuatorType
    if (currentStep === 2) {
      if (basicForm !== initialState[2].filter.basicForm) {
        state[2].filter.attributes = state[2].filter.attributes.filter(
          filterItem =>
            !['ActuatorFunction', 'ActuatorSupplyPressure'].includes(
              filterItem.attributeIdentifier,
            ),
        );
        if (basicForm === 'gearbox') {
          state[2].filter.attributes = state[2].filter.attributes.filter(
            filterItem =>
              !['ActuatorMediumType'].includes(filterItem.attributeIdentifier),
          );
        }
      } else {
        state[2].filter.attributes = initialState[2].filter.attributes;
      }
    }
  },
  setBasicFormForMonitoring(state, action) {
    const { monitoringType, currentStep } = action.payload;
    state[currentStep].filter.attributes = initialState[
      currentStep
    ].filter.attributes.map(filterItem => {
      if (filterItem.attributeIdentifier === 'EGTF_3734__STRING') {
        return {
          ...filterItem,
          values: [monitoringType],
        };
      }
      return filterItem;
    });
  },
  removeFilterAttribute(state, action: PayloadAction<any>) {
    const { currentStep, attributeIdentifier, inputType } = action.payload;
    if (
      inputType === 'radioGroup' &&
      attributeIdentifier !== 'EF022666__STRING'
    ) {
      state[currentStep].filter.attributes = state[
        currentStep
      ].filter.attributes.map(filterItem => {
        if (filterItem.attributeIdentifier === attributeIdentifier) {
          return initialState[currentStep].filter.attributes.find(
            item => item.attributeIdentifier === attributeIdentifier,
          );
        }
        return filterItem;
      });
    } else {
      state[currentStep].filter.attributes = state[
        currentStep
      ].filter.attributes.filter(
        filterItem => filterItem.attributeIdentifier !== attributeIdentifier,
      );
    }
  },
  removeAllFilterAttributes(state, action: PayloadAction<any>) {
    for (let i = action.payload.selectedStep + 1; i <= 4; i++) {
      state[i].filter = initialState[i].filter;
    }
  },
  resetAllFilterAttributes(state, action: PayloadAction<any>) {
    state[action.payload.currentStep].filter =
      initialState[action.payload.currentStep].filter;
  },
  resetBasicForm(state, action: PayloadAction<any>) {
    const { currentStep } = action.payload;
    const initialBasicForm = initialState[currentStep].filter.attributes.find(
      item => item.attributeIdentifier === 'basicForm',
    )?.values[0];
    state[currentStep].filter.basicForm =
      initialState[currentStep].filter.basicForm;
    //resetting default filters for step 2
    state[currentStep].filter.attributes =
      initialState[currentStep].filter.attributes;
    state[currentStep].filter.attributes = state[
      currentStep
    ].filter.attributes.map(filterItem => {
      if (filterItem.attributeIdentifier === 'basicForm') {
        return {
          ...filterItem,
          values: [initialBasicForm],
        };
      }
      return filterItem;
    });
  },
  removeUnmatchedFilters(state, action: PayloadAction<any>) {
    const { currentStep, filterData } = action.payload;
    const itemExists = state[currentStep].filter.attributes.find(
      item => item.attributeIdentifier === filterData.attributeIdentifier,
    );

    if (itemExists) {
      state[currentStep].filter.attributes = state[
        currentStep
      ].filter.attributes.map(item => {
        if (item.attributeIdentifier === filterData.attributeIdentifier) {
          const unmatchedValues = item.values.filter(
            val => val !== filterData.value,
          );
          return {
            ...item,
            values: unmatchedValues,
          };
        }
        return item;
      });
    }
  },
};
